import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DeviceUiUiStateService<T> {
	public readonly uiStateMap = signal<Map<string, Partial<T>>>(new Map());
	private readonly _uiStateMap: Map<string, Partial<T>> = new Map();

	public updateOrCreateSlice(state: Partial<T>, identifier: string): void {
		this._uiStateMap.set(identifier, {
			...(<T>{}),
			...this._uiStateMap.get(identifier),
			...state
		});

		this.uiStateMap.set(new Map(this._uiStateMap));
	}
}
